import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import "./Packages.css";
import { useMediaQuery } from "react-responsive";

export const BlackFriday = () => {
  const isMobile = useMediaQuery({ maxWidth: "450px" });
  const packages = [
    {
      id: 7,
      title: "7 Days Tanzania Safari",
      category: 'Safaris',
      img: "https://skyrocklabourconsultants.com/assets/img/6-days-tanzania-safari.jpg",
      destination: "Tanzania",
      duration: "7 Days 6 Nights",
      numberppl: "1-8 Person",
      price: "$3150",
      newprice: "$2678",
      description: "Embark on an unforgettable 7-day Tanzania safari adventure that takes you through the most spectacular wildlife destinations in Africa.",
      url: "/SevenDaysTanzaniaSafari"
    },
    {
      id: 11,
      title: "8 Days Tanzania Affordable Safari",
      category: 'Safaris',
      img: "https://africantraveltour.com/assets/img/8-days-tanzania-affordable-safari.jpg",
      destination: "Tanzania",
      duration: "8 Days 7 Nights",
      numberppl: "1-8 Person",
      price: "$3600",
      newprice: "$3060",
      description: "This 8-day Safari and Adventure holiday will take your breath away, filling you with lifetime memories.",
      url: "/EightDaysTanzaniaAffordableSafari"
    },
    {
      id: 8,
      title: "9 Days Serengati Great Migration",
      category: 'Safaris',
      img: "https://africantraveltour.com/assets/img/9-days-serengati-great-migration.jpg",
      destination: "Tanzania",
      duration: "9 Days 8 Nights",
      numberppl: "1-8 Person",
      price: "$4050",
      newprice: "$3443",
      description: "This 9-day safari will take your breath away.",
      url: "/NineDaysSafari"
    },
    {
      id: 9,
      title: "11 Days Chimpanzee Trekking At Mahale And Gombe",
      category: 'Safaris',
      img: "https://skyrocklabourconsultants.com/assets/img/11-days-chimpanzee-trekking-at-mahale-and-gombe.jpg",
      destination: "Tanzania",
      duration: "11 Days 10 Nights",
      numberppl: "1-8 Person",
      price: "$4950",
      newprice: "$4208",
      description: "Primate adventure deep into Tanzania's western wilderness.",
      url: "/ElevenDaysChimpanzeeTrekkingMahaleGombe"
    },

    {
      id: 12,
      title: "8 Days Kilimanjaro Climb - Lemosho Route",
      img: "https://africantraveltour.com/assets/img/packagetananiazan1/pk5img.png",
      destination: "Tanzania & Zanzibar",
      duration: "8 Days 7 Nights",
      numberppl: "1-8 Person",
      price: "$2578",
      newprice: "$2191",
      description: "The Lemosho Route is often considered the most beautiful trail up Mount Kilimanjaro.",
      url: "/EightDayskilimanjaroclimb"
    },

    {
      id: 13,
      title: "7 Days Zanzibar Honeymooners Holiday",
      img: "https://africantraveltour.com/assets/img/packagetananiazan1/pk4img.png",
      destination: "Tanzania & Zanzibar",
      duration: "7 Days 6 Nights",
      numberppl: "1-8 Person",
      price: "$4200",
      newprice: "$3570",
      description: "Escape to the tropical paradise of Zanzibar.",
      url: "/SevenDaysZanzibarHoneymoonersHoliday"
    },

    {
      id: 14,
      title: "6 Days Trip To Kilimanjaro And Safari",
      category: 'Safaris',
      img: "https://africantraveltour.com/assets/img/packagetananiazan1/pk3img.png",
      destination: "Tanzania & Zanzibar",
      duration: "6 Days 5 Nights",
      numberppl: "1-8 Person",
      price: "$1953",
      newprice: "$1660",
      description: "This African gem is the highest peak of the continent.",
      url: "/SixDAYSDAYTRIPTOKILIMANJAROANDSAFARI"
    },

    {
      id: 1,
      title: "1 Day Nyerere National Park Tour",
      img: "https://skyrocklabourconsultants.com/assets/img/1-day-nyerere-national-park-tour.jpg",
      destination: "Tanzania",
      duration: "1 Day",
      numberppl: "1-8 Person",
      price: "$450",
      newprice: "$383",
      description: "Experience Africa's largest national park.",
      url: "/OneDayNyerereNationalParkTour"
    },

    {
      id: 4,
      title: "2 Days Tanzania safari",
      img: "https://africantraveltour.com/assets/img/2-days-tanzania-safaris.jpg",
      destination: "Tanzania",
      duration: "2 Days 1 Nights",
      numberppl: "1-8 Person",
      price: "$900",
      newprice: "$765",
      description: "Experience the best of Northern Tanzania's wildlife.",
      url: "/TwoDaysTanzaniasafari"
    },

    {
      id: 5,
      title: "3 Days Tanzania safari",
      category: 'Safaris',
      img: "https://africantraveltour.com/assets/img/3-days-tanzania-safari.jpg",
      destination: "Tanzania",
      duration: "3 Days 2 Nights",
      numberppl: "1-8 Person",
      price: "$1350",
      newprice: "$1148",
      description: "Ultimate Northern Tanzania safari adventure.",
      url: "/ThreeDaysTanzaniaSafaris"
    }
  ];



  // Helpers
  const parsePrice = (price) => Number(price.replace(/[^0-9.-]+/g, ""));
  const extractDays = (duration) => {
    const match = duration.match(/(\d+)\s*Day/);
    return match ? parseInt(match[1]) : 0;
  };

  // Filters
  const destinations = ["Safari Destination", ...new Set(packages.map((pkg) => pkg.destination.trim()))];
  const categories = ["Tour Category", ...new Set(packages.map((pkg) => pkg.category).filter(Boolean))];
  const priceRanges = [
    { label: "Safari Budget", min: 0, max: Infinity },
    { label: "Under $1000", min: 0, max: 1000 },
    { label: "$1000 - $2000", min: 1000, max: 2000 },
    { label: "$2000 - $3000", min: 2000, max: 3000 },
    { label: "Above $3000", min: 3000, max: Infinity },
  ];
  const durationRanges = [
    { label: "Safari Duration", min: 0, max: Infinity },
    { label: "1 - 3 Days", min: 1, max: 3 },
    { label: "4 - 6 Days", min: 4, max: 6 },
    { label: "7 - 11 Days", min: 7, max: 11 },

  ];

  // States
  const [selectedCategory, setSelectedCategory] = useState("Tour Category");
  const [selectedDestination, setSelectedDestination] = useState("Safari Destination");
  const [selectedPriceRange, setSelectedPriceRange] = useState("Safari Budget");
  const [selectedDurationRange, setSelectedDurationRange] = useState("Safari Duration");
  const [filtersApplied, setFiltersApplied] = useState({
    category: "Tour Category",
    destination: "Safari Destination",
    priceRange: "Safari Budget",
    durationRange: "Safari Duration"
  });

  // Pagination
  const itemsPerPage = 9;
  const [currentPage, setCurrentPage] = useState(1);

  // Apply filters
  const handleFindTour = () => {
    setFiltersApplied({
      category: selectedCategory,
      destination: selectedDestination,
      priceRange: selectedPriceRange,
      durationRange: selectedDurationRange,
    });
    setCurrentPage(1);
  };

  // Filtering logic
  const filteredPackages = packages.filter((pkg) => {
    const pkgPrice = parsePrice(pkg.price);
    const pkgDays = extractDays(pkg.duration);

    const priceRange = priceRanges.find((r) => r.label === filtersApplied.priceRange) || priceRanges[0];
    const durationRange = durationRanges.find((r) => r.label === filtersApplied.durationRange) || durationRanges[0];

    const matchesPrice = pkgPrice >= priceRange.min && pkgPrice <= priceRange.max;
    const matchesDuration = pkgDays >= durationRange.min && pkgDays <= durationRange.max;
    const matchesDestination = filtersApplied.destination === "Safari Destination" || pkg.destination.trim() === filtersApplied.destination;
    const matchesCategory = filtersApplied.category === "Tour Category" || pkg.category === filtersApplied.category;

    return matchesPrice && matchesDuration && matchesDestination && matchesCategory;
  });

  const totalPages = Math.ceil(filteredPackages.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentPackages = filteredPackages.slice(startIndex, startIndex + itemsPerPage);
  const backgroundUrl = "https://africantraveltour.com/assets/img/african15desk.png";
  const BackgroundMobile = 'https://africantraveltour.com/assets/img/african15mobile.png'

  return (
    <div style={{
      position: "relative",
      zIndex: 100,
      backgroundImage: "var(--bg-image)",
      backgroundAttachment: "fixed",
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}>
      <Helmet>
        <title>Tanzania Safari Tours | African Travel Tour</title>
        <meta
          name="description"
          content="Explore safari tours across Tanzania, and East Africa. From luxury safaris to hiking adventures, find the perfect tailor-made package."
        />
      </Helmet>

      {/* Hero Section */}
      <div className="d-none d-md-block" style={{ paddingTop: '11vh', backgroundColor: '#00000075' }}></div>
      <div
        className="text-white d-flex align-items-center"
        style={{
          backgroundImage: `url(${isMobile ? BackgroundMobile : backgroundUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: `${isMobile ? '50vh' : '40vh'}`,
          position: "relative",

        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            zIndex: 1,
          }}
        ></div>

      </div>

      {/* Filter Bar */}
      <div className="container mb-4 py-4 search-bar d-flex flex-column justify-content-center align-items-center">
        <div className="aboutUs-Intro pb-3 wow fadeInUp text-center">
          <p >
            Go wild this Black Friday with <span className="accent pulse-button"> African Travel Tour. </span> Explore Tanzania and Zanzibar’s breathtaking landscapes, witness extraordinary wildlife,
            and enjoy unforgettable safari moments now with exclusive savings up to 5%.
          </p>
        </div>

        <div className="row g-2 justify-content-center align-items-center">
          {/* Category 
              <div className="col-12 col-md-3">
                <select className="form-select" value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
                  {categories.map((cat, index) => <option key={index} value={cat}>{cat}</option>)}
                </select>
              </div>
              */}

          {/* Destination */}
          <div className="col-12 col-md-4">
            <select className="form-select" value={selectedDestination} onChange={(e) => setSelectedDestination(e.target.value)}>
              {destinations.map((dest, index) => <option key={index} value={dest}>{dest}</option>)}
            </select>
          </div>

          {/* Price Range   */}
          <div className="col-12 col-md-3">
            <select className="form-select" value={selectedPriceRange} onChange={(e) => setSelectedPriceRange(e.target.value)}>
              {priceRanges.map((range, index) => <option key={index} value={range.label}>{range.label}</option>)}
            </select>
          </div>


          {/* Duration Range */}
          <div className="col-12 col-md-4">
            <select className="form-select" value={selectedDurationRange} onChange={(e) => setSelectedDurationRange(e.target.value)}>
              {durationRanges.map((range, index) => <option key={index} value={range.label}>{range.label}</option>)}
            </select>
          </div>

          {/* Button */}
          <div className="col-12 col-md-4 d-grid ">
            <button className="btn btn-primary fw-bold" style={{ borderColor: "white" }} onClick={handleFindTour}>
              Find Your Tour
            </button>
          </div>
        </div>

        <hr className="w-50 mx-auto mt-5" style={{ borderTop: "2px solid #000" }} />
        <hr className="w-25 mx-auto mt-1" style={{ borderTop: "2px solid #000" }} />
      </div>

      {/* Packages */}
      <div className="container-xxl py-2">
        <div className="container">
          <div className="row g-4 justify-content-center">
            {currentPackages.length > 0 ? (
              currentPackages.map((pkg) => (
                <div key={pkg.id} className="col-lg-4 col-md-6">
                  <div className="package-item h-100 d-flex flex-column">
                    <div className="overflow-hidden position-relative">
                      <img loading="lazy" className="img-fluid" src={pkg.img} alt={pkg.destination} />
                      <span
                        className="position-absolute top-0 end-0 m-2 px-3 py-2 text-white rounded-pill fw-bold text-center"
                        style={{ fontSize: "0.9rem", backgroundColor: '#446400' }}
                      >
                        From  <span style={{ textDecoration: "line-through", textDecorationThickness: "1px" }}>
                          {pkg.price} <br />
                        </span>  {pkg.newprice}/PAX
                      </span>
                    </div>
                    <div className="d-flex border-bottom">
                      <small className="flex-fill text-center border-end py-2">
                        <i className="fa fa-map-marker-alt  me-2" style={{ color: "#446400" }} />
                        {pkg.destination}
                      </small>
                      <small className="flex-fill text-center border-end py-2">
                        <i className="fa fa-calendar-alt  me-2" style={{ color: "#446400" }} />
                        {pkg.duration}
                      </small>


                    </div>
                    <div className="text-center p-4 flex-grow-1 d-flex flex-column justify-content-between">
                      <div>
                        <h4 className="mb-2" style={{ color: "#446400" }}>{pkg.title}</h4>
                        <p style={{
                          textAlign: "justify",
                          textAlignLast: "center"
                        }}>{pkg.description}</p>
                      </div>
                      <div className="d-flex justify-content-center mt-3">
                        <a href={pkg.url} className="btn btn-sm btn-primary px-3" style={{ borderRadius: "30px" }}>Read More</a>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center">No tours match your criteria.</p>
            )}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-center mt-4">
              <nav>
                <ul className="pagination">
                  {Array.from({ length: totalPages }, (_, index) => (
                    <li key={index} className={`page-item ${currentPage === index + 1 ? "active" : ""}`}>
                      <button
                        className="page-link"
                        onClick={() => {
                          setCurrentPage(index + 1);
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                      >
                        {index + 1}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
